import * as React from "react"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import Dialog from "@components/Dialog"
import { FormControl, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material"
import { ContractFamilyInfo } from "@store/authAtoms"

interface Props {
  options: ContractFamilyInfo[]
  open: boolean
  dialogTitle: string
  onClose: (cancel: boolean, value: string) => void
}

export default function ConfirmContractDialog({ options, open, dialogTitle, onClose }: Props) {
  const [chosenContract, setChosenContract] = React.useState<string>("")
  const [showWarning, setShowWarning] = React.useState<boolean>(false)

  const handleChange = (event: SelectChangeEvent) => {
    const {
      target: { value },
    } = event
    setChosenContract(value)
  }

  return (
    <Dialog
      open={open}
      onClose={() => onClose(true, "n/a")}
      title={dialogTitle}
      actionsComponent={
        <DialogActions>
          <Button onClick={() => onClose(true, "n/a")} variant="contained">
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (chosenContract) {
                setShowWarning(false)
                onClose(false, chosenContract)
              } else {
                setShowWarning(true)
              }
            }}
            color="error"
            variant="contained"
          >
            Yes
          </Button>
        </DialogActions>
      }
    >
      <>
        <Typography variant={"h6"}>
          {" "}
          You are a member of multiple eligible build contracts. Who should be able to see this
          graph?
        </Typography>
        <Typography>Please select which contract to assign this graph to.</Typography>
        <Typography>
          BEWARE: This affects who can see this graph . <b>Confirm first.</b>
        </Typography>
        <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
          {showWarning && <b>YOU MUST CHOOSE A CONTRACT!</b>}
          <Select
            displayEmpty
            value={chosenContract}
            renderValue={(selected) => {
              if (selected == "") {
                return <em>Choose contract</em>
              }

              return selected
            }}
            onChange={handleChange}
            sx={{ fontSize: "small", mt: 1 }}
          >
            {options.map((contractKey) => (
              <MenuItem key={contractKey.contract_key} value={contractKey.contract_key}>
                {contractKey.description} - {contractKey.contract_key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    </Dialog>
  )
}
